// core
import ButtonModal from './core/ButtonModal'
import Imgix from './core/Imgix'
import {ixPolyfill} from './core/Imgix'
import Waypoints from './core/Waypoints'
import LightboxGallery from './core/LightboxGallery'
import SiteVitals from './core/SiteVitals'

// modules
import Navigation from './modules/Navigation'
import Accordion from './modules/Accordion'
import Grid from './modules/Grid'
import Slider from './modules/Slider'

// core
new Imgix();
new Waypoints();
new LightboxGallery();
new SiteVitals()
new ButtonModal();

// imgix polyfill for core
ixPolyfill();

// modules
new Navigation()
new Accordion();

document.querySelectorAll("[data-module=grid]").forEach((el) => {
    new Grid(el)
})
document.querySelectorAll("[data-module=slider]").forEach((el) => {
    new Slider(el)
})
document.querySelectorAll("[data-module=lightbox-gallery],[data-module=slider]").forEach((el) => {
    new LightboxGallery(el);
})

document.querySelector("[data-module=enquiry-form]").addEventListener('click', () => {
    document.body.classList.toggle('is-enquiry')
})

// Prevent esbuild from using either of jQuery or underscore global function names
// as these are both used externally
_ = _.noConflict();
$ = $.noConflict();
